export default [
  {
    name: 'kyc/verify-id',
    path: '/kyc/verify-id',
    component: () => import('@/pages/kyc/verify/Id.vue'),
  },
  {
    name: 'kyc/verify-id/confirm',
    path: '/kyc/verify-id/confirm',
    component: () => import('@/pages/kyc/verify/Confirm.vue'),
  },
  {
    name: 'kyc/verify-id/success',
    path: '/kyc/verify-id/success',
    component: () => import('@/pages/kyc/verify/Success.vue'),
  },
  {
    name: 'kyc/verify-id/failure',
    path: '/kyc/verify-id/failure',
    component: () => import('@/pages/kyc/verify/Failure.vue'),
  },
  {
    name: 'kyc/verify-id-card',
    path: '/kyc/verify-id-card',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/kyc/verify/IdCard.vue'),
  },
  {
    name: 'kyc/verify-id-card/complete',
    path: '/kyc/verify-id-card/complete',
    component: () => import('@/pages/kyc/verify/CompleteKyc.vue'),
  },
]
